module.exports = __webpack_public_path__ + "img/breakfast_title--forbid.877265a0.png";